import React, { useState } from "react";
import styles from "./AddProgram.module.css";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import { FaUserPlus } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import { LuUpload } from "react-icons/lu";
import { saveLeave } from "../../redux/slices/leaveSlice";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";

// ✅ Each student now has a unique ID
const dummyStudents = [
  { id: "s1", name: "John" },
  { id: "s2", name: "Steeve" },
  { id: "s3", name: "John" },
  { id: "s4", name: "Steeve" },
  { id: "s5", name: "John" },
  { id: "s6", name: "Steeve" },
  { id: "s7", name: "John" },
  { id: "s8", name: "Steeve" },
  { id: "s9", name: "John" },
  { id: "s10", name: "Steeve" },
];

const AddProgram = () => {
  const dispatch = useDispatch();
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [search, setSearch] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);

  const [leaveType, setLeaveType] = useState("");
  const [reason, setReason] = useState("");
 


  const [programName, setProgramName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [days, setDays] = useState([]);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [label, setLabel] = useState("");
  const [room, setRoom] = useState("");
  const [maxStudents, setMaxStudents] = useState("");
  const [maxStaff, setMaxStaff] = useState("");
  const [aboveCapStudent, setAboveCapStudent] = useState(false);
  const [aboveCapStaff, setAboveCapStaff] = useState(false);
  const [minAgeYrs, setMinAgeYrs] = useState("0");
  const [minAgeMonths, setMinAgeMonths] = useState("0");
  const [maxAgeYrs, setMaxAgeYrs] = useState("0");
  const [maxAgeMonths, setMaxAgeMonths] = useState("0");
  const allDays = ["Mon", "Tues", "Wed", "Thur", "Fri", "Sat", "Sun"];

  const handleToggleDay = (day) => {
    setDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const validateRequiredFields = () => {
    if (
      !programName ||
      !fromDate ||
      !toDate ||
      days.length === 0 ||
      !startTime ||
      !endTime ||
      !label ||
      !room
    ) {
      alert("Please fill in all required fields (*)");
      return false;
    }
    return true;
  };

  const handleProgramSave = () => {
    if (!validateRequiredFields()) return;

    console.log({
      programName,
      fromDate,
      toDate,
      days,
      startTime,
      endTime,
      label,
      room,
      aboveCapStudent,
      aboveCapStaff,
      maxStudents,
      maxStaff,
      minAgeYrs,
      minAgeMonths,
      maxAgeYrs,
      maxAgeMonths,
    });
  };

  const handleProgramCancel = () => {
    setProgramName("");
    setFromDate("");
    setToDate("");
    setDays([]);
    setStartTime("");
    setEndTime("");
    setLabel("");
    setRoom("");
    setAboveCapStudent(false);
    setAboveCapStaff(false);
    setMaxStudents("");
    setMaxStaff("");
    setMinAgeYrs("0");
    setMinAgeMonths("0");
    setMaxAgeYrs("0");
    setMaxAgeMonths("0");
  };

  const handleCheckboxChange = (id) => {
    setSelectedStudents((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const filteredStudents = dummyStudents.filter((student) =>
    student.name.toLowerCase().includes(search.toLowerCase())
  );
  const handleClose = () => {
    dispatch(closeModal());
  };
  const handleSave = () => {
    const leaveEntry = {
      fromDate,
      toDate,
      leaveType,
      reason,
      attachment: uploadedFile,
    };

    dispatch(saveLeave(leaveEntry));
    dispatch(closeModal());
  };

  const handleCancel = () => {
    setSelectedStudents([]); // clear all checkboxes
    setSearch("");
    setLeaveType("");
    setReason("");
    setFromDate("");
    setToDate("");
    // clear search input
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeadingAndIcon icon={<FaUserPlus />} heading="Add Program" />
        <ToClose onClose={handleClose} />
      </div>

      <div className={styles.sectionCard}>
        <div className={styles.sectionHeader}>
          <HeadingAndIcon  heading="Program Details" />
        </div>
        <div className={styles.studentdata}>
          <div className={styles.row}>
            <HeadingAndData
              label="Program Name"
              name="programName"
              placeholder="Enter Program name"
              value={programName}
              onChange={(e) => setProgramName(e.target.value)}
              required
            />
            <HeadingAndData
              label="From"
              name="fromDate"
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              required
            />
            <HeadingAndData
              label="To"
              name="toDate"
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              required
            />
          </div>

          <div className={styles.row65_35}>
            <div className={styles.col65}>
              <label className={styles.inputLabel}>
                Select Days of the week{" "}
                <span className={styles.required}>*</span>
              </label>
              <div className={styles.dayButtonGroup}>
                {allDays.map((day) => (
                  <button
                    key={day}
                    type="button"
                    className={`${styles.dayButton} ${
                      days.includes(day) ? styles.activeDay : ""
                    }`}
                    onClick={() => handleToggleDay(day)}
                  >
                    {day}
                  </button>
                ))}
              </div>
            </div>

            <div className={styles.col35}>
              <HeadingAndData
                label="Start time"
                name="startTime"
                placeholder="Choose Start time"
                type="time"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                required
              />
            </div>
          </div>

          <div className={styles.customGridRow}>
            <div className={styles.col5}>
              <HeadingAndData
                label="End time"
                name="endTime"
                placeholder="Choose End time"
                type="time"
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                required
              />
            </div>

            <div className={styles.col3}>
              <HeadingAndDropDown
                label="Labels"
                name="label"
                value={label}
                onChange={(e) => setLabel(e.target.value)}
                required
                options={[
                  { label: "Summer", value: "summer" },
                  { label: "Winter", value: "winter" },
                ]}
                placeholder="Select labels"
              />
            </div>

            <div className={styles.col3}>
              <HeadingAndDropDown
                label="Rooms"
                name="room"
                value={room}
                onChange={(e) => setRoom(e.target.value)}
                required
                options={[
                  { label: "Room A", value: "room_a" },
                  { label: "Room B", value: "room_b" },
                ]}
                placeholder="Select rooms"
              />
            </div>
          </div>

          <div className={styles.customGridRow}>
            <div className={styles.col5}>
              <label className={styles.inputLabel}>
                Allow Admissions Above Max.capacity
                <span className={styles.required}> *</span>
              </label>
              <div className={styles.checkboxRow}>
                <label className={styles.checkLabel}>
                  <input
                    type="checkbox"
                    checked={aboveCapStudent}
                    onChange={(e) => setAboveCapStudent(e.target.checked)}
                  />{" "}
                  Students
                </label>
                <label className={styles.checkLabel}>
                  <input
                    type="checkbox"
                    checked={aboveCapStaff}
                    onChange={(e) => setAboveCapStaff(e.target.checked)}
                  />{" "}
                  Staff
                </label>
              </div>
            </div>

            <div className={styles.col3}>
              <HeadingAndData
                label="Max.Students"
                name="maxStudents"
                placeholder="Choose capacity"
                value={maxStudents}
                onChange={(e) => setMaxStudents(e.target.value)}
              />
            </div>

            <div className={styles.col3}>
              <HeadingAndData
                label="Max.Staff"
                name="maxStaff"
                placeholder="Choose capacity"
                value={maxStaff}
                onChange={(e) => setMaxStaff(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.row}>
            <HeadingAndData
              label="Minimum age(yrs)"
              name="minAgeYrs"
              type="number"
              value={minAgeYrs}
              onChange={(e) => setMinAgeYrs(e.target.value)}
            />
            <HeadingAndData
              label="Minimum age(months)"
              name="minAgeMonths"
              type="number"
              value={minAgeMonths}
              onChange={(e) => setMinAgeMonths(e.target.value)}
            />
          </div>

          <div className={styles.row}>
            <HeadingAndData
              label="Maximum age(yrs)"
              name="maxAgeYrs"
              type="number"
              value={maxAgeYrs}
              onChange={(e) => setMaxAgeYrs(e.target.value)}
            />
            <HeadingAndData
              label="Maximum age(months)"
              name="maxAgeMonths"
              type="number"
              value={maxAgeMonths}
              onChange={(e) => setMaxAgeMonths(e.target.value)}
            />
          </div>

          <div className={styles.footerActions}>
            <SaveAndCancel
              onSave={handleProgramSave}
              onCancel={handleProgramCancel}
            />
          </div>
        </div>
      </div>

      <div className={styles.sectionCard}>
        <div className={styles.sectionHeader}>
          <HeadingAndIcon icon={<FaUserPlus />} heading="Assign Students" />
        </div>
        <div className={styles.studentdata}>
          <div className={styles.controls}>
            <SearchBar
              placeholder="Search Student"
              onChange={(e) => setSearch(e.target.value)}
            />
            <Dropdown
              bgColor="var(--Utility_Color9)"
              label="Room"
              options={["Room A", "Room B"]}
            />
          </div>

          <div className={styles.listHeader}>
            <label>
              <input
                type="checkbox"
                checked={selectedStudents.length === filteredStudents.length}
                onChange={(e) =>
                  setSelectedStudents(
                    e.target.checked ? filteredStudents.map((s) => s.id) : []
                  )
                }
              />{" "}
              Select All
            </label>
            <span>{selectedStudents.length} Selected</span>
          </div>

          <div className={styles.grid}>
            {filteredStudents.map((student) => (
              <label key={student.id} className={styles.studentBox}>
                <input
                  type="checkbox"
                  checked={selectedStudents.includes(student.id)}
                  onChange={() => handleCheckboxChange(student.id)}
                />
                <span>{student.name}</span>
              </label>
            ))}
          </div>

          <div className={styles.footerActions}>
            <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
          </div>
        </div>
      </div>

      <div className={styles.sectionCard}>
        <div className={styles.sectionHeader}>
          <HeadingAndIcon icon={<FaUserPlus />} heading="Assign Staff" />
        </div>
        <div className={styles.studentdata}>
          <div className={styles.controls}>
            <SearchBar
              placeholder="Search Staff"
              onChange={(e) => setSearch(e.target.value)}
            />
            <Dropdown
              bgColor="var(--Utility_Color9)"
              label="Room"
              options={["Room A", "Room B"]}
            />
          </div>

          <div className={styles.listHeader}>
            <label>
              <input
                type="checkbox"
                checked={selectedStudents.length === filteredStudents.length}
                onChange={(e) =>
                  setSelectedStudents(
                    e.target.checked ? filteredStudents.map((s) => s.id) : []
                  )
                }
              />{" "}
              Select All
            </label>
            <span>{selectedStudents.length} Selected</span>
          </div>

          <div className={styles.grid}>
            {filteredStudents.map((student) => (
              <label key={student.id} className={styles.studentBox}>
                <input
                  type="checkbox"
                  checked={selectedStudents.includes(student.id)}
                  onChange={() => handleCheckboxChange(student.id)}
                />
                <span>{student.name}</span>
              </label>
            ))}
          </div>

          <div className={styles.footerActions}>
            <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProgram;
